export default "/directory/static/performs_non_religious.fca406e2.svg";